<template>
  <!-- Rendered only when there is something to say: an app with no links and
       the credit switched off leaves no empty strip under the card. -->
  <footer v-if="links.length || poweredBy" class="sh-foot-links">
    <nav v-if="links.length" class="sh-foot-links__row" :aria-label="t('footer.helpLegal')">
      <a
        v-for="link in links"
        :key="link.key"
        :href="link.href"
        :class="`sh-foot-links__${link.key}`"
        :target="link.href.startsWith('mailto:') ? undefined : '_blank'"
        rel="noopener noreferrer"
        >{{ t(footerKey(link.key)) }}</a>
    </nav>
    <span v-if="poweredBy" class="sh-foot-links__credit">{{ t("footer.poweredBy") }}</span>
    <LanguagePicker compact />
  </footer>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useSessionStore } from "@/stores/session";
import { preAuthLinks, showPoweredBy } from "@/tenant/loginLinks";
import LanguagePicker from "@/shell/LanguagePicker.vue";

/** Support, legal and the vendor credit — the same strip under every
 *  pre-auth card (Login, OrgPicker, NoAccess, Unavailable). */
export default defineComponent({
  name: "PreAuthFooter",
  components: { LanguagePicker },
  setup() {
    const { t } = useI18n();
    const session = useSessionStore();
    const links = computed(() => preAuthLinks(session.tenant?.loginPage));
    const poweredBy = computed(() => showPoweredBy(session.tenant?.loginPage, session.tenant?.name || "Metaship"));
    function footerKey(key: "support" | "terms" | "privacy"): string {
      if (key === "support") return "footer.needHelp";
      if (key === "terms") return "footer.terms";
      return "footer.privacy";
    }
    return { t, links, poweredBy, footerKey };
  },
});
</script>
